import { useFormik } from "formik";
import * as Yup from "yup";
import { useState } from "react";
import { useAuth } from "../../Providers/AuthProvider";
import addNewPackage from "../../services/addNewPackage";
import { useUser } from "../../Providers/UserProvider";
import DifinitionForm from "../DifinitionForm/DifinitionForm";
import { toast } from "react-toastify";
import "animate.css";
import TrackVisibility from "react-on-screen";

const TourDefinitionFormFirstStep = ({
  nextStepHandler,
  nextStepFlag,
  stepFlag,
}) => {
  const initialValues = {
    packageName: "",
    packageType: "0",
    PackageRule: "",
    PackagePublishState: "",
    PackageStartDate: "",
    PackageFinishDate: "",
    PackageSources: [],
    PackageDestinations: [],
  };

  const validationSchema = Yup.object({
    packageName: Yup.string()
      .required("لطفا نام تور را وارد نمایید.")
      .min(6, "نام تور حداقل باید شامل شش کارکتر باشد."),
    packageType: Yup.object().required("لطفا نوع تور را انتخاب نمایید.."),
    //PackageRule: Yup.object().required("لطفاقابلیت رزرو تور خود را مشخص کنید."),
    PackagePublishState: Yup.object().required(
      "لطفا وضعیت نمایش در سایت را مشخص کنید."
    ),
    PackageStartDate: Yup.string().required(
      "لطفا تاریخ شروع برگزاری تور خود را وارد نمایید."
    ),
    PackageFinishDate: Yup.string().required(
      "لطفا تاریخ پایان برگزاری تور خود را وارد نمایید."
    ),
    PackageSources: Yup.array().required("لطفا مبدا تور خود را وارد نمایید."),
    PackageDestinations: Yup.array().required(
      "لطفا نقصد تور خود را وارد نمایید."
    ),
  });
  const packageNameOptions = [{ value: "Hiking", label: "طبیعت‌گردی" }];
  const PackagePublishOptions = [
    { value: 1, label: "ندارد" },
    { value: 0, label: "دارد" },
  ];

  const { stateAuth } = useAuth();
  const user = useUser();
  const floatingCompanyId = user.FloatingCompanyId;
  const [error, setError] = useState(null);

  const onSubmit = async (values) => {
    const {
      packageName,
      packageType,
      PackageRule,
      PackagePublishState,
      PackageStartDate,
      PackageFinishDate,
      PackageSources,
      PackageDestinations,
    } = values;
    const userData = {
      packageName,
      packageType: packageType.value,
      FloatingCompanyId: floatingCompanyId,
      PackageRule: btoa(unescape(encodeURIComponent(PackageRule))),
      PackagePublishState: PackagePublishState.value,
      PackageStartDate,
      PackageFinishDate,
      PackageSources: PackageSources.map((item) => item.value).toString(),
      PackageDestinations: PackageDestinations.map(
        (item) => item.value
      ).toString(),
      PackageState: 0,
      PackageTourLeader: "",
      PackageId: "",
    };
    try {
      const header = {
        headers: {
          token: stateAuth,
        },
      };
      console.log(userData);
      const { data } = await addNewPackage(userData, header);
      toast.success(`${userData.packageName} به لیست تور‌ها اضافه شد.`);
      formik.resetForm();
      if (stepFlag) {
        nextStepHandler(data.Value.Id, 1);
      }
      if (!stepFlag) {
        nextStepHandler(data.Value.Id, 0);
      }
    } catch (error) {
      if (error.response && error.response.data.message) {
        setError(error.response.data.message);
        toast.error(error);
      }
    }
  };

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit,
    validationSchema,
    validateOnMount: true,
    enableReinitialize: true,
  });
  return (
    <TrackVisibility once>
      {({ isVisible }) =>
        isVisible && (
          <form
            className="flex flex-wrap justify-start animate__animated animate__fadeIn"
            onSubmit={formik.handleSubmit}
          >
            <DifinitionForm
              formik={formik}
              packageNameOptions={packageNameOptions}
              PackagePublishOptions={PackagePublishOptions}
              nextStepFlag={nextStepFlag}
              PackageRuleValue={initialValues.PackageRule}
            />
            {error && <p style={{ color: "red" }}>{error}</p>}
          </form>
        )
      }
    </TrackVisibility>
  );
};

export default TourDefinitionFormFirstStep;
